import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const fetchDashboard = () => {
  return Api(endPoints.getDashboard, {}, requestType.GET);
};
export { fetchDashboard };
